import { Text } from '@/components/ui/text'
import SetupAuthor from '@components/SetupAuthor'
import type { Tables } from '@hvf/contracts'
import dayjs from 'dayjs'
import { css } from 'styled-system/css'
import { Flex, Grid } from 'styled-system/jsx'

export default function Creation(props: { setup: Tables<'setup'> }) {

  return (
    <Grid gridTemplateColumns='1fr' alignItems='start' gap='10px'>

      <SetupAuthor
        createdBy={props.setup?.created_by}
        avatarSize='40px'
        rankSize='19px'
        nameFontSize='13.5px'
        created_at={props.setup?.created_at}
      />

      <Grid gap='4px'>
        <Flex gap='8px' fontSize='11px' color='editorialInk3'>
          <Text
            minW='62px'
            fontSize='11px'
            color='editorialInk3'
          >
            Published
          </Text>
          <Text
            fontSize='11px'
            color='editorialInk3'
            class={css({ fontVariantNumeric: 'tabular-nums' })}
          >
            {dayjs(props.setup.created_at).format('DD MMM YYYY - LT')}
          </Text>
        </Flex>
        <Flex gap='8px' fontSize='11px' color='editorialInk3'>
          <Text
            minW='62px'
            fontSize='11px'
            color='editorialInk3'
          >
            Modified
          </Text>
          <Text
            fontSize='11px'
            color='editorialInk3'
            class={css({ fontVariantNumeric: 'tabular-nums' })}
          >
            {dayjs(props.setup.updated_at).format('DD MMM YYYY - LT')}
          </Text>
        </Flex>
      </Grid>

    </Grid >
  )
}
